import { onErrorDefault } from '@occc-app/dataAccessLayer/utils';
import {
  RetailerNetworkTobaccoProgramOverviewFilter,
  useRetailerNetworkTobaccoProgramMetricsOverviewQuery,
} from '@occc/graphql';

export const useRetailerNetworkTobaccoProgramMetricsOverview = (
  filter: RetailerNetworkTobaccoProgramOverviewFilter,
) => {
  return useRetailerNetworkTobaccoProgramMetricsOverviewQuery({
    fetchPolicy: 'cache-and-network',
    notifyOnNetworkStatusChange: true,
    onError: onErrorDefault,
    variables: {
      filter,
    },
  });
};
